/**
 * #wiki_msg.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal.js";
import { BoolValue, Int64Value, StringValue } from "../../../../google/protobuf/wrappers.js";
import { messageTypeRegistry } from "../../../../typeRegistry.js";
import { WrappedUserObject } from "../common/common_msg.js";
function createBaseGetWikiPagesRequest() {
    return { subreddit: "" };
}
export const GetWikiPagesRequest = {
    $type: "devvit.plugin.redditapi.wiki.GetWikiPagesRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetWikiPagesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "" };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        return obj;
    },
    create(base) {
        return GetWikiPagesRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetWikiPagesRequest();
        message.subreddit = object.subreddit ?? "";
        return message;
    },
};
messageTypeRegistry.set(GetWikiPagesRequest.$type, GetWikiPagesRequest);
function createBaseGetWikiPagesResponse() {
    return { kind: "", data: [] };
}
export const GetWikiPagesResponse = {
    $type: "devvit.plugin.redditapi.wiki.GetWikiPagesResponse",
    encode(message, writer = _m0.Writer.create()) {
        if (message.kind !== "") {
            writer.uint32(10).string(message.kind);
        }
        for (const v of message.data) {
            writer.uint32(18).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetWikiPagesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.kind = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.data.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
            data: globalThis.Array.isArray(object?.data) ? object.data.map((e) => globalThis.String(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.kind !== "") {
            obj.kind = message.kind;
        }
        if (message.data?.length) {
            obj.data = message.data;
        }
        return obj;
    },
    create(base) {
        return GetWikiPagesResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetWikiPagesResponse();
        message.kind = object.kind ?? "";
        message.data = object.data?.map((e) => e) || [];
        return message;
    },
};
messageTypeRegistry.set(GetWikiPagesResponse.$type, GetWikiPagesResponse);
function createBaseGetWikiPageRequest() {
    return { subreddit: "", page: "", revisionId: undefined };
}
export const GetWikiPageRequest = {
    $type: "devvit.plugin.redditapi.wiki.GetWikiPageRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        if (message.page !== "") {
            writer.uint32(18).string(message.page);
        }
        if (message.revisionId !== undefined) {
            StringValue.encode({ value: message.revisionId }, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetWikiPageRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.page = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.revisionId = StringValue.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
            page: isSet(object.page) ? globalThis.String(object.page) : "",
            revisionId: isSet(object.revisionId) ? String(object.revisionId) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        if (message.page !== "") {
            obj.page = message.page;
        }
        if (message.revisionId !== undefined) {
            obj.revisionId = message.revisionId;
        }
        return obj;
    },
    create(base) {
        return GetWikiPageRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetWikiPageRequest();
        message.subreddit = object.subreddit ?? "";
        message.page = object.page ?? "";
        message.revisionId = object.revisionId ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(GetWikiPageRequest.$type, GetWikiPageRequest);
function createBaseWikiPage() {
    return {
        contentMd: "",
        contentHtml: "",
        revisionId: "",
        revisionDate: 0,
        mayRevise: false,
        reason: undefined,
        revisionBy: undefined,
    };
}
export const WikiPage = {
    $type: "devvit.plugin.redditapi.wiki.WikiPage",
    encode(message, writer = _m0.Writer.create()) {
        if (message.contentMd !== "") {
            writer.uint32(10).string(message.contentMd);
        }
        if (message.contentHtml !== "") {
            writer.uint32(18).string(message.contentHtml);
        }
        if (message.revisionId !== "") {
            writer.uint32(26).string(message.revisionId);
        }
        if (message.revisionDate !== 0) {
            writer.uint32(32).int64(message.revisionDate);
        }
        if (message.mayRevise !== false) {
            writer.uint32(40).bool(message.mayRevise);
        }
        if (message.reason !== undefined) {
            StringValue.encode({ value: message.reason }, writer.uint32(50).fork()).ldelim();
        }
        if (message.revisionBy !== undefined) {
            WrappedUserObject.encode(message.revisionBy, writer.uint32(58).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWikiPage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.contentMd = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.contentHtml = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.revisionId = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.revisionDate = longToNumber(reader.int64());
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.mayRevise = reader.bool();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.reason = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.revisionBy = WrappedUserObject.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            contentMd: isSet(object.contentMd) ? globalThis.String(object.contentMd) : "",
            contentHtml: isSet(object.contentHtml) ? globalThis.String(object.contentHtml) : "",
            revisionId: isSet(object.revisionId) ? globalThis.String(object.revisionId) : "",
            revisionDate: isSet(object.revisionDate) ? globalThis.Number(object.revisionDate) : 0,
            mayRevise: isSet(object.mayRevise) ? globalThis.Boolean(object.mayRevise) : false,
            reason: isSet(object.reason) ? String(object.reason) : undefined,
            revisionBy: isSet(object.revisionBy) ? WrappedUserObject.fromJSON(object.revisionBy) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.contentMd !== "") {
            obj.contentMd = message.contentMd;
        }
        if (message.contentHtml !== "") {
            obj.contentHtml = message.contentHtml;
        }
        if (message.revisionId !== "") {
            obj.revisionId = message.revisionId;
        }
        if (message.revisionDate !== 0) {
            obj.revisionDate = Math.round(message.revisionDate);
        }
        if (message.mayRevise !== false) {
            obj.mayRevise = message.mayRevise;
        }
        if (message.reason !== undefined) {
            obj.reason = message.reason;
        }
        if (message.revisionBy !== undefined) {
            obj.revisionBy = WrappedUserObject.toJSON(message.revisionBy);
        }
        return obj;
    },
    create(base) {
        return WikiPage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWikiPage();
        message.contentMd = object.contentMd ?? "";
        message.contentHtml = object.contentHtml ?? "";
        message.revisionId = object.revisionId ?? "";
        message.revisionDate = object.revisionDate ?? 0;
        message.mayRevise = object.mayRevise ?? false;
        message.reason = object.reason ?? undefined;
        message.revisionBy = (object.revisionBy !== undefined && object.revisionBy !== null)
            ? WrappedUserObject.fromPartial(object.revisionBy)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(WikiPage.$type, WikiPage);
function createBaseGetWikiPageResponse() {
    return { kind: "", data: undefined };
}
export const GetWikiPageResponse = {
    $type: "devvit.plugin.redditapi.wiki.GetWikiPageResponse",
    encode(message, writer = _m0.Writer.create()) {
        if (message.kind !== "") {
            writer.uint32(10).string(message.kind);
        }
        if (message.data !== undefined) {
            WikiPage.encode(message.data, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetWikiPageResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.kind = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.data = WikiPage.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
            data: isSet(object.data) ? WikiPage.fromJSON(object.data) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.kind !== "") {
            obj.kind = message.kind;
        }
        if (message.data !== undefined) {
            obj.data = WikiPage.toJSON(message.data);
        }
        return obj;
    },
    create(base) {
        return GetWikiPageResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetWikiPageResponse();
        message.kind = object.kind ?? "";
        message.data = (object.data !== undefined && object.data !== null) ? WikiPage.fromPartial(object.data) : undefined;
        return message;
    },
};
messageTypeRegistry.set(GetWikiPageResponse.$type, GetWikiPageResponse);
function createBaseEditWikiPageRequest() {
    return { subreddit: "", page: "", content: "", reason: "" };
}
export const EditWikiPageRequest = {
    $type: "devvit.plugin.redditapi.wiki.EditWikiPageRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        if (message.page !== "") {
            writer.uint32(18).string(message.page);
        }
        if (message.content !== "") {
            writer.uint32(26).string(message.content);
        }
        if (message.reason !== "") {
            writer.uint32(34).string(message.reason);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEditWikiPageRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.page = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.content = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.reason = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
            page: isSet(object.page) ? globalThis.String(object.page) : "",
            content: isSet(object.content) ? globalThis.String(object.content) : "",
            reason: isSet(object.reason) ? globalThis.String(object.reason) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        if (message.page !== "") {
            obj.page = message.page;
        }
        if (message.content !== "") {
            obj.content = message.content;
        }
        if (message.reason !== "") {
            obj.reason = message.reason;
        }
        return obj;
    },
    create(base) {
        return EditWikiPageRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEditWikiPageRequest();
        message.subreddit = object.subreddit ?? "";
        message.page = object.page ?? "";
        message.content = object.content ?? "";
        message.reason = object.reason ?? "";
        return message;
    },
};
messageTypeRegistry.set(EditWikiPageRequest.$type, EditWikiPageRequest);
function createBaseHideWikiPageRevisionRequest() {
    return { subreddit: "", page: "", revision: "" };
}
export const HideWikiPageRevisionRequest = {
    $type: "devvit.plugin.redditapi.wiki.HideWikiPageRevisionRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        if (message.page !== "") {
            writer.uint32(18).string(message.page);
        }
        if (message.revision !== "") {
            writer.uint32(26).string(message.revision);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHideWikiPageRevisionRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.page = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.revision = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
            page: isSet(object.page) ? globalThis.String(object.page) : "",
            revision: isSet(object.revision) ? globalThis.String(object.revision) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        if (message.page !== "") {
            obj.page = message.page;
        }
        if (message.revision !== "") {
            obj.revision = message.revision;
        }
        return obj;
    },
    create(base) {
        return HideWikiPageRevisionRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseHideWikiPageRevisionRequest();
        message.subreddit = object.subreddit ?? "";
        message.page = object.page ?? "";
        message.revision = object.revision ?? "";
        return message;
    },
};
messageTypeRegistry.set(HideWikiPageRevisionRequest.$type, HideWikiPageRevisionRequest);
function createBaseHideWikiPageRevisionResponse() {
    return { status: false };
}
export const HideWikiPageRevisionResponse = {
    $type: "devvit.plugin.redditapi.wiki.HideWikiPageRevisionResponse",
    encode(message, writer = _m0.Writer.create()) {
        if (message.status !== false) {
            writer.uint32(8).bool(message.status);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHideWikiPageRevisionResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.status = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { status: isSet(object.status) ? globalThis.Boolean(object.status) : false };
    },
    toJSON(message) {
        const obj = {};
        if (message.status !== false) {
            obj.status = message.status;
        }
        return obj;
    },
    create(base) {
        return HideWikiPageRevisionResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseHideWikiPageRevisionResponse();
        message.status = object.status ?? false;
        return message;
    },
};
messageTypeRegistry.set(HideWikiPageRevisionResponse.$type, HideWikiPageRevisionResponse);
function createBaseGetWikiPageRevisionsRequest() {
    return {
        subreddit: "",
        page: "",
        after: undefined,
        before: undefined,
        limit: undefined,
        count: undefined,
        show: undefined,
        srDetail: undefined,
    };
}
export const GetWikiPageRevisionsRequest = {
    $type: "devvit.plugin.redditapi.wiki.GetWikiPageRevisionsRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        if (message.page !== "") {
            writer.uint32(18).string(message.page);
        }
        if (message.after !== undefined) {
            StringValue.encode({ value: message.after }, writer.uint32(26).fork()).ldelim();
        }
        if (message.before !== undefined) {
            StringValue.encode({ value: message.before }, writer.uint32(34).fork()).ldelim();
        }
        if (message.limit !== undefined) {
            Int64Value.encode({ value: message.limit }, writer.uint32(42).fork()).ldelim();
        }
        if (message.count !== undefined) {
            Int64Value.encode({ value: message.count }, writer.uint32(50).fork()).ldelim();
        }
        if (message.show !== undefined) {
            BoolValue.encode({ value: message.show }, writer.uint32(58).fork()).ldelim();
        }
        if (message.srDetail !== undefined) {
            BoolValue.encode({ value: message.srDetail }, writer.uint32(66).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetWikiPageRevisionsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.page = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.after = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.before = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.limit = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.count = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.show = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.srDetail = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
            page: isSet(object.page) ? globalThis.String(object.page) : "",
            after: isSet(object.after) ? String(object.after) : undefined,
            before: isSet(object.before) ? String(object.before) : undefined,
            limit: isSet(object.limit) ? Number(object.limit) : undefined,
            count: isSet(object.count) ? Number(object.count) : undefined,
            show: isSet(object.show) ? Boolean(object.show) : undefined,
            srDetail: isSet(object.srDetail) ? Boolean(object.srDetail) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        if (message.page !== "") {
            obj.page = message.page;
        }
        if (message.after !== undefined) {
            obj.after = message.after;
        }
        if (message.before !== undefined) {
            obj.before = message.before;
        }
        if (message.limit !== undefined) {
            obj.limit = message.limit;
        }
        if (message.count !== undefined) {
            obj.count = message.count;
        }
        if (message.show !== undefined) {
            obj.show = message.show;
        }
        if (message.srDetail !== undefined) {
            obj.srDetail = message.srDetail;
        }
        return obj;
    },
    create(base) {
        return GetWikiPageRevisionsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetWikiPageRevisionsRequest();
        message.subreddit = object.subreddit ?? "";
        message.page = object.page ?? "";
        message.after = object.after ?? undefined;
        message.before = object.before ?? undefined;
        message.limit = object.limit ?? undefined;
        message.count = object.count ?? undefined;
        message.show = object.show ?? undefined;
        message.srDetail = object.srDetail ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(GetWikiPageRevisionsRequest.$type, GetWikiPageRevisionsRequest);
function createBaseWikiPageRevision() {
    return { id: "", page: "", timestamp: 0, reason: "", revisionHidden: false, author: undefined };
}
export const WikiPageRevision = {
    $type: "devvit.plugin.redditapi.wiki.WikiPageRevision",
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.page !== "") {
            writer.uint32(18).string(message.page);
        }
        if (message.timestamp !== 0) {
            writer.uint32(24).int64(message.timestamp);
        }
        if (message.reason !== "") {
            writer.uint32(34).string(message.reason);
        }
        if (message.revisionHidden !== false) {
            writer.uint32(40).bool(message.revisionHidden);
        }
        if (message.author !== undefined) {
            WrappedUserObject.encode(message.author, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWikiPageRevision();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.page = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.timestamp = longToNumber(reader.int64());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.reason = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.revisionHidden = reader.bool();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.author = WrappedUserObject.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            page: isSet(object.page) ? globalThis.String(object.page) : "",
            timestamp: isSet(object.timestamp) ? globalThis.Number(object.timestamp) : 0,
            reason: isSet(object.reason) ? globalThis.String(object.reason) : "",
            revisionHidden: isSet(object.revisionHidden) ? globalThis.Boolean(object.revisionHidden) : false,
            author: isSet(object.author) ? WrappedUserObject.fromJSON(object.author) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.page !== "") {
            obj.page = message.page;
        }
        if (message.timestamp !== 0) {
            obj.timestamp = Math.round(message.timestamp);
        }
        if (message.reason !== "") {
            obj.reason = message.reason;
        }
        if (message.revisionHidden !== false) {
            obj.revisionHidden = message.revisionHidden;
        }
        if (message.author !== undefined) {
            obj.author = WrappedUserObject.toJSON(message.author);
        }
        return obj;
    },
    create(base) {
        return WikiPageRevision.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWikiPageRevision();
        message.id = object.id ?? "";
        message.page = object.page ?? "";
        message.timestamp = object.timestamp ?? 0;
        message.reason = object.reason ?? "";
        message.revisionHidden = object.revisionHidden ?? false;
        message.author = (object.author !== undefined && object.author !== null)
            ? WrappedUserObject.fromPartial(object.author)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(WikiPageRevision.$type, WikiPageRevision);
function createBaseWikiPageRevisionListing() {
    return { kind: "", data: undefined };
}
export const WikiPageRevisionListing = {
    $type: "devvit.plugin.redditapi.wiki.WikiPageRevisionListing",
    encode(message, writer = _m0.Writer.create()) {
        if (message.kind !== "") {
            writer.uint32(10).string(message.kind);
        }
        if (message.data !== undefined) {
            WikiPageRevisionListing_Data.encode(message.data, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWikiPageRevisionListing();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.kind = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.data = WikiPageRevisionListing_Data.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
            data: isSet(object.data) ? WikiPageRevisionListing_Data.fromJSON(object.data) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.kind !== "") {
            obj.kind = message.kind;
        }
        if (message.data !== undefined) {
            obj.data = WikiPageRevisionListing_Data.toJSON(message.data);
        }
        return obj;
    },
    create(base) {
        return WikiPageRevisionListing.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWikiPageRevisionListing();
        message.kind = object.kind ?? "";
        message.data = (object.data !== undefined && object.data !== null)
            ? WikiPageRevisionListing_Data.fromPartial(object.data)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(WikiPageRevisionListing.$type, WikiPageRevisionListing);
function createBaseWikiPageRevisionListing_Data() {
    return { after: undefined, before: undefined, children: [], dist: undefined };
}
export const WikiPageRevisionListing_Data = {
    $type: "devvit.plugin.redditapi.wiki.WikiPageRevisionListing.Data",
    encode(message, writer = _m0.Writer.create()) {
        if (message.after !== undefined) {
            StringValue.encode({ value: message.after }, writer.uint32(10).fork()).ldelim();
        }
        if (message.before !== undefined) {
            StringValue.encode({ value: message.before }, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.children) {
            WikiPageRevision.encode(v, writer.uint32(26).fork()).ldelim();
        }
        if (message.dist !== undefined) {
            Int64Value.encode({ value: message.dist }, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWikiPageRevisionListing_Data();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.after = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.before = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.children.push(WikiPageRevision.decode(reader, reader.uint32()));
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.dist = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            after: isSet(object.after) ? String(object.after) : undefined,
            before: isSet(object.before) ? String(object.before) : undefined,
            children: globalThis.Array.isArray(object?.children)
                ? object.children.map((e) => WikiPageRevision.fromJSON(e))
                : [],
            dist: isSet(object.dist) ? Number(object.dist) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.after !== undefined) {
            obj.after = message.after;
        }
        if (message.before !== undefined) {
            obj.before = message.before;
        }
        if (message.children?.length) {
            obj.children = message.children.map((e) => WikiPageRevision.toJSON(e));
        }
        if (message.dist !== undefined) {
            obj.dist = message.dist;
        }
        return obj;
    },
    create(base) {
        return WikiPageRevisionListing_Data.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWikiPageRevisionListing_Data();
        message.after = object.after ?? undefined;
        message.before = object.before ?? undefined;
        message.children = object.children?.map((e) => WikiPageRevision.fromPartial(e)) || [];
        message.dist = object.dist ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(WikiPageRevisionListing_Data.$type, WikiPageRevisionListing_Data);
function createBaseGetWikiRevisionsRequest() {
    return {
        subreddit: "",
        after: undefined,
        before: undefined,
        limit: undefined,
        count: undefined,
        show: undefined,
        srDetail: undefined,
    };
}
export const GetWikiRevisionsRequest = {
    $type: "devvit.plugin.redditapi.wiki.GetWikiRevisionsRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        if (message.after !== undefined) {
            StringValue.encode({ value: message.after }, writer.uint32(18).fork()).ldelim();
        }
        if (message.before !== undefined) {
            StringValue.encode({ value: message.before }, writer.uint32(26).fork()).ldelim();
        }
        if (message.limit !== undefined) {
            Int64Value.encode({ value: message.limit }, writer.uint32(34).fork()).ldelim();
        }
        if (message.count !== undefined) {
            Int64Value.encode({ value: message.count }, writer.uint32(42).fork()).ldelim();
        }
        if (message.show !== undefined) {
            BoolValue.encode({ value: message.show }, writer.uint32(50).fork()).ldelim();
        }
        if (message.srDetail !== undefined) {
            BoolValue.encode({ value: message.srDetail }, writer.uint32(58).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetWikiRevisionsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.after = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.before = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.limit = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.count = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.show = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.srDetail = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
            after: isSet(object.after) ? String(object.after) : undefined,
            before: isSet(object.before) ? String(object.before) : undefined,
            limit: isSet(object.limit) ? Number(object.limit) : undefined,
            count: isSet(object.count) ? Number(object.count) : undefined,
            show: isSet(object.show) ? Boolean(object.show) : undefined,
            srDetail: isSet(object.srDetail) ? Boolean(object.srDetail) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        if (message.after !== undefined) {
            obj.after = message.after;
        }
        if (message.before !== undefined) {
            obj.before = message.before;
        }
        if (message.limit !== undefined) {
            obj.limit = message.limit;
        }
        if (message.count !== undefined) {
            obj.count = message.count;
        }
        if (message.show !== undefined) {
            obj.show = message.show;
        }
        if (message.srDetail !== undefined) {
            obj.srDetail = message.srDetail;
        }
        return obj;
    },
    create(base) {
        return GetWikiRevisionsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetWikiRevisionsRequest();
        message.subreddit = object.subreddit ?? "";
        message.after = object.after ?? undefined;
        message.before = object.before ?? undefined;
        message.limit = object.limit ?? undefined;
        message.count = object.count ?? undefined;
        message.show = object.show ?? undefined;
        message.srDetail = object.srDetail ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(GetWikiRevisionsRequest.$type, GetWikiRevisionsRequest);
function createBaseRevertWikiPageRequest() {
    return { subreddit: "", page: "", revision: "" };
}
export const RevertWikiPageRequest = {
    $type: "devvit.plugin.redditapi.wiki.RevertWikiPageRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        if (message.page !== "") {
            writer.uint32(18).string(message.page);
        }
        if (message.revision !== "") {
            writer.uint32(26).string(message.revision);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRevertWikiPageRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.page = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.revision = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
            page: isSet(object.page) ? globalThis.String(object.page) : "",
            revision: isSet(object.revision) ? globalThis.String(object.revision) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        if (message.page !== "") {
            obj.page = message.page;
        }
        if (message.revision !== "") {
            obj.revision = message.revision;
        }
        return obj;
    },
    create(base) {
        return RevertWikiPageRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRevertWikiPageRequest();
        message.subreddit = object.subreddit ?? "";
        message.page = object.page ?? "";
        message.revision = object.revision ?? "";
        return message;
    },
};
messageTypeRegistry.set(RevertWikiPageRequest.$type, RevertWikiPageRequest);
function createBaseGetWikiPageSettingsRequest() {
    return { subreddit: "", page: "" };
}
export const GetWikiPageSettingsRequest = {
    $type: "devvit.plugin.redditapi.wiki.GetWikiPageSettingsRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        if (message.page !== "") {
            writer.uint32(18).string(message.page);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetWikiPageSettingsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.page = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
            page: isSet(object.page) ? globalThis.String(object.page) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        if (message.page !== "") {
            obj.page = message.page;
        }
        return obj;
    },
    create(base) {
        return GetWikiPageSettingsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetWikiPageSettingsRequest();
        message.subreddit = object.subreddit ?? "";
        message.page = object.page ?? "";
        return message;
    },
};
messageTypeRegistry.set(GetWikiPageSettingsRequest.$type, GetWikiPageSettingsRequest);
function createBaseWikiPageSettings() {
    return { kind: "", data: undefined };
}
export const WikiPageSettings = {
    $type: "devvit.plugin.redditapi.wiki.WikiPageSettings",
    encode(message, writer = _m0.Writer.create()) {
        if (message.kind !== "") {
            writer.uint32(10).string(message.kind);
        }
        if (message.data !== undefined) {
            WikiPageSettings_Data.encode(message.data, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWikiPageSettings();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.kind = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.data = WikiPageSettings_Data.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
            data: isSet(object.data) ? WikiPageSettings_Data.fromJSON(object.data) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.kind !== "") {
            obj.kind = message.kind;
        }
        if (message.data !== undefined) {
            obj.data = WikiPageSettings_Data.toJSON(message.data);
        }
        return obj;
    },
    create(base) {
        return WikiPageSettings.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWikiPageSettings();
        message.kind = object.kind ?? "";
        message.data = (object.data !== undefined && object.data !== null)
            ? WikiPageSettings_Data.fromPartial(object.data)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(WikiPageSettings.$type, WikiPageSettings);
function createBaseWikiPageSettings_Data() {
    return { permLevel: 0, editors: [], listed: false };
}
export const WikiPageSettings_Data = {
    $type: "devvit.plugin.redditapi.wiki.WikiPageSettings.Data",
    encode(message, writer = _m0.Writer.create()) {
        if (message.permLevel !== 0) {
            writer.uint32(8).int32(message.permLevel);
        }
        for (const v of message.editors) {
            WrappedUserObject.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.listed !== false) {
            writer.uint32(24).bool(message.listed);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWikiPageSettings_Data();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.permLevel = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.editors.push(WrappedUserObject.decode(reader, reader.uint32()));
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.listed = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            permLevel: isSet(object.permLevel) ? globalThis.Number(object.permLevel) : 0,
            editors: globalThis.Array.isArray(object?.editors)
                ? object.editors.map((e) => WrappedUserObject.fromJSON(e))
                : [],
            listed: isSet(object.listed) ? globalThis.Boolean(object.listed) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.permLevel !== 0) {
            obj.permLevel = Math.round(message.permLevel);
        }
        if (message.editors?.length) {
            obj.editors = message.editors.map((e) => WrappedUserObject.toJSON(e));
        }
        if (message.listed !== false) {
            obj.listed = message.listed;
        }
        return obj;
    },
    create(base) {
        return WikiPageSettings_Data.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWikiPageSettings_Data();
        message.permLevel = object.permLevel ?? 0;
        message.editors = object.editors?.map((e) => WrappedUserObject.fromPartial(e)) || [];
        message.listed = object.listed ?? false;
        return message;
    },
};
messageTypeRegistry.set(WikiPageSettings_Data.$type, WikiPageSettings_Data);
function createBaseUpdateWikiPageSettingsRequest() {
    return { subreddit: "", page: "", permlevel: 0, listed: "" };
}
export const UpdateWikiPageSettingsRequest = {
    $type: "devvit.plugin.redditapi.wiki.UpdateWikiPageSettingsRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        if (message.page !== "") {
            writer.uint32(18).string(message.page);
        }
        if (message.permlevel !== 0) {
            writer.uint32(24).int32(message.permlevel);
        }
        if (message.listed !== "") {
            writer.uint32(34).string(message.listed);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateWikiPageSettingsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.page = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.permlevel = reader.int32();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.listed = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
            page: isSet(object.page) ? globalThis.String(object.page) : "",
            permlevel: isSet(object.permlevel) ? globalThis.Number(object.permlevel) : 0,
            listed: isSet(object.listed) ? globalThis.String(object.listed) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        if (message.page !== "") {
            obj.page = message.page;
        }
        if (message.permlevel !== 0) {
            obj.permlevel = Math.round(message.permlevel);
        }
        if (message.listed !== "") {
            obj.listed = message.listed;
        }
        return obj;
    },
    create(base) {
        return UpdateWikiPageSettingsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateWikiPageSettingsRequest();
        message.subreddit = object.subreddit ?? "";
        message.page = object.page ?? "";
        message.permlevel = object.permlevel ?? 0;
        message.listed = object.listed ?? "";
        return message;
    },
};
messageTypeRegistry.set(UpdateWikiPageSettingsRequest.$type, UpdateWikiPageSettingsRequest);
function createBaseAllowEditorRequest() {
    return { subreddit: "", page: "", act: "", username: "" };
}
export const AllowEditorRequest = {
    $type: "devvit.plugin.redditapi.wiki.AllowEditorRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        if (message.page !== "") {
            writer.uint32(18).string(message.page);
        }
        if (message.act !== "") {
            writer.uint32(26).string(message.act);
        }
        if (message.username !== "") {
            writer.uint32(34).string(message.username);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAllowEditorRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.page = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.act = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.username = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
            page: isSet(object.page) ? globalThis.String(object.page) : "",
            act: isSet(object.act) ? globalThis.String(object.act) : "",
            username: isSet(object.username) ? globalThis.String(object.username) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        if (message.page !== "") {
            obj.page = message.page;
        }
        if (message.act !== "") {
            obj.act = message.act;
        }
        if (message.username !== "") {
            obj.username = message.username;
        }
        return obj;
    },
    create(base) {
        return AllowEditorRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAllowEditorRequest();
        message.subreddit = object.subreddit ?? "";
        message.page = object.page ?? "";
        message.act = object.act ?? "";
        message.username = object.username ?? "";
        return message;
    },
};
messageTypeRegistry.set(AllowEditorRequest.$type, AllowEditorRequest);
function longToNumber(long) {
    if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    return long.toNumber();
}
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long;
    _m0.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
